(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    class QuantityInput {
    constructor(element) {
      this.container = element;
      this.input = this.container.querySelector('.quantity-input__field');
      this.minusButton = this.container.querySelector('.quantity-input__button--minus');
      this.plusButton = this.container.querySelector('.quantity-input__button--plus');
      
      this.min = parseInt(this.input.min) || 1;
      this.max = parseInt(this.input.max) || 99;
      
      this.init();
    }

    init() {
      if (!this.input) return;
      
      this.setupEventListeners();
      this.updateButtonStates();
    }

    setupEventListeners() {
      this.minusButton?.addEventListener('click', () => {
        this.decrease();
      });

      this.plusButton?.addEventListener('click', () => {
        this.increase();
      });

      this.input.addEventListener('input', () => {
        this.validateInput();
        this.updateButtonStates();
      });

      this.input.addEventListener('blur', () => {
        this.validateInput();
        this.updateButtonStates();
      });
    }

    decrease() {
      const currentValue = parseInt(this.input.value) || this.min;
      if (currentValue > this.min) {
        this.input.value = currentValue - 1;
        this.updateButtonStates();
        this.triggerChange();
      }
    }

    increase() {
      const currentValue = parseInt(this.input.value) || this.min;
      if (currentValue < this.max) {
        this.input.value = currentValue + 1;
        this.updateButtonStates();
        this.triggerChange();
      }
    }

    validateInput() {
      let value = parseInt(this.input.value);
      
      if (isNaN(value) || value < this.min) {
        value = this.min;
      } else if (value > this.max) {
        value = this.max;
      }
      
      this.input.value = value;
    }

    updateButtonStates() {
      const currentValue = parseInt(this.input.value) || this.min;
      
      if (this.minusButton) {
        this.minusButton.disabled = currentValue <= this.min;
      }
      
      if (this.plusButton) {
        this.plusButton.disabled = currentValue >= this.max;
      }
    }

    triggerChange() {
      // Dispatch a custom event for other components to listen to
      this.input.dispatchEvent(new CustomEvent('quantity-change', {
        detail: { value: parseInt(this.input.value) },
        bubbles: true
      }));
    }
  }

  // Initialize quantity inputs when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    const quantityInputs = document.querySelectorAll('[data-quantity-input]');
    quantityInputs.forEach(input => {
      new QuantityInput(input);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
